import { db, type MosDB } from "./db";
import { type WeeklySummary, weeklySummary } from "./weekly-summary";

/**
 * Summaries for several weeks from local data. The tables are read once, so
 * a history of many weeks costs one load, not one per week.
 */
export async function loadWeeklySummaries(
	weeks: string[],
	today: string,
	database: MosDB = db,
): Promise<WeeklySummary[]> {
	const [
		tasks,
		habits,
		logs,
		reviews,
		transactions,
		budgets,
		categories,
		focusSessions,
		studySessions,
		tracks,
	] = await Promise.all([
		database.tasks.toArray(),
		database.habits.toArray(),
		database.habit_logs.toArray(),
		database.reviews.toArray(),
		database.transactions.toArray(),
		database.budgets.toArray(),
		database.categories.toArray(),
		database.focus_sessions.toArray(),
		database.study_sessions.toArray(),
		database.tracks.toArray(),
	]);
	const minimumDays = new Set(
		reviews
			.filter((r) => r.kind === "morning" && r.minimum_day && !r.deleted_at)
			.map((r) => r.date),
	);
	return weeks.map((week) =>
		weeklySummary({
			week,
			today,
			tasks,
			habits,
			logs,
			minimumDays,
			transactions,
			budgets,
			categories,
			focusSessions,
			studySessions,
			tracks,
		}),
	);
}
